import {useEffect, useState} from 'react';

export type ColorScheme = 'light' | 'dark';

const lightQuery = '(prefers-color-scheme: light)';

export const getSystemColorScheme = (): ColorScheme => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'dark';
  }
  return window.matchMedia(lightQuery).matches ? 'light' : 'dark';
};

export const useSystemColorScheme = (): ColorScheme => {
  const [scheme, setScheme] = useState<ColorScheme>(getSystemColorScheme);

  useEffect(() => {
    const media = window.matchMedia(lightQuery);
    const onChange = () => {
      setScheme(media.matches ? 'light' : 'dark');
    };
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }
    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, []);

  return scheme;
};
